(() => {
    // remove base product from bundle
    function customAddToCart() {
      if (!!window._cpb.settings === false) window._cpb.settings = {}
      window._cpb.settings.addToCartOverride = async data => {
          const baseProduct = data.items.find(item => item.properties._image);
          data.items.splice(data.items.indexOf(baseProduct), 1);
          console.log(data);
          fetch("/cart/add.js", {
              "headers": {
                  "content-type": "application/json;charset=UTF-8"
              },
              "body": JSON.stringify({
                  items: data.items
              }),
              "method": "POST"
          }).then(() => {
              // if(data.redirect) location.href = '/cart'
          })
      }
    }

    const mobilePreviewNoShrink = () => {
      const builder = document.querySelector('#product-builder');
      const previewSticky = document.querySelector('.cpb-preview-sticky');
      const previewLayers = document.querySelector('.cpb-preview-layers');
      const previeElements = document.querySelector('.cpb-preview-elements');

      const update = () => {
        setTimeout(() => {
          const unshrinkedHeight = previewSticky.getAttribute('style').match(/height:.+px;/img)[0].split(' ')[1].replace(';', '');
          console.log(unshrinkedHeight);
          builder.style.setProperty('--unshrinked-height', `${unshrinkedHeight}`);
        }, 100);
      }

      builder.dataset.unshrinkedHeight = true;
      
      update();
      document.querySelector('.personalize-it--js').addEventListener('click', update);
      document.body.addEventListener('CPB_ON_RENDER_LAYERS', update);
      window.addEventListener('resize', update);
    }

    const changeLoadingText = () => {
      const textMap = {
        "Loading shop data...": "Preparing your exclusive collection…",
        "Loading config...": "Setting up your Charm Bar…",
        "Loading product variants...": "Your next Hair Drama fix is almost ready!",
      };
      const observerMap = new WeakMap();
      const observeTextSwap = (el) => {
        if (!el || observerMap.has(el)) return;
        const observer = new MutationObserver(() => {
          const currentText = el.textContent.trim();
          if (textMap[currentText]) {
            el.textContent = textMap[currentText];
          }
        });
        observer.observe(el, {
          childList: true,
          characterData: true,
          subtree: true
        });
        const initialText = el.textContent.trim();
        if (textMap[initialText]) {
          el.textContent = textMap[initialText];
        }
    
          observerMap.set(el, observer);
        };
        const waitForElement = (selector, callback) => {
          const check = () => {
            const el = document.querySelector(selector);
            if (el) {
              callback(el);
              return true;
            }
            return false;
          };
          if (!check()) {
            const interval = setInterval(() => {
              if (check()) clearInterval(interval);
            }, 200);
          }
        };
        waitForElement('.cpb-loader-text', observeTextSwap);
    }
  
    function replaceLoadingInventoryText() {
      const targetSelector = '.cpb-aside-suspense span';
      const targetText = 'Loading inventory...';
      const replacementText = 'Adding some last Dramatic touches…';
      const waitForElement = (selector, callback) => {
        const check = () => {
          const el = document.querySelector(selector);
          console.log(el, 'el')
          if (el) {
            callback(el);
            return true;
          }
          return false;
        };
    
        if (!check()) {
          const interval = setInterval(() => {
            if (check()) clearInterval(interval);
          }, 200);
        }
      };
      const observeAndReplace = (el) => {
        const observer = new MutationObserver(() => {
          const current = el.textContent.trim();
          if (current === targetText) {
            el.textContent = replacementText;
          }
        });
    
        observer.observe(el, {
          childList: true,
          characterData: true,
          subtree: true
        });
        const current = el.textContent.trim();
        if (current === targetText) {
          el.textContent = replacementText;
        }
      };
      waitForElement(targetSelector, observeAndReplace);
    }

    document.addEventListener('DOMContentLoaded', () => {
      changeLoadingText()
      
    });

    document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
      if (CPB.getStore().getState().Global.inventoryModeBundle) customAddToCart();
      mobilePreviewNoShrink();
      // replaceLoadingInventoryText()
    })
})()